import * as React from "react"
import { cva } from "class-variance-authority"

import { cn } from "../../lib/utils"

const inputVariants = cva(
  "flex w-full rounded-md border transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none",
  {
    variants: {
      variant: {
        // Default shadcn/ui style (kept for backward compatibility)
        default:
          "h-9 border-input bg-transparent px-3 py-1 text-base shadow-sm file:text-foreground placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring md:text-sm",
        // Runcards mobile design style (matches mobile app)
        runcards:
          "h-10 border-runcards-border bg-runcards-background px-runcards-sm py-runcards-sm rounded-runcards-md text-runcards-sm font-runcards text-runcards-text-primary placeholder:text-runcards-text-secondary focus-visible:border-runcards-border-medium min-h-[40px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Input = React.forwardRef(({ className, type, variant, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(inputVariants({ variant }), className)}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input, inputVariants }
